<template>
<span>
  <span class="popup-target" :data-position="position">
    <slot></slot>
  </span>
  <div class="ui popup">
    <p class="linebreak">{{ contents }}</p>
  </div>
</span>
</template>

<script>
export default {
    props: {
        contents: {
            required: true,
            type: String
        },
        position: {
            required: false,
            type: String,
            default: 'right center'
        }
    },
    mounted: function() {
        $('.popup-target', this.$el).popup({
            inline: true,
            hoverable: true
        });
    }
};
</script>
